if (!customElements.get('swatch-media-gallery-simple')) {
    customElements.define('swatch-media-gallery-simple', class SwatchMediaGallerySimple extends HTMLElement {
      constructor() {
        super();
        this.checkVisibility();
      }

      checkVisibility() {
        $(this).on('change', function(e) {
            $('img', this).hide();
            var $activeGallery = $('img[data-swatch="'+e.detail.swatch.replace(' ', '_')+'"]', this)
            $activeGallery.show();
        })
        var currentSwatch = $(this).data('current-swatch');
        $('img', this).hide();
        $('img[data-swatch="'+currentSwatch.replace(' ', '_')+'"]', this).show();
      }
    });
}